import React from 'react';
import { API } from './shared';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const isHome = typeof window !== 'undefined' && window.location.pathname === '/';
  const anchor = (hash) => isHome ? hash : `/${hash}`;

  const handleCtaClick = () => {
    if (isHome) {
      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/#contact';
    }
  };

  return (
    <footer className="bg-[#0B1A2B] text-white mt-16" data-testid="footer">
      <div className="container-luxury pt-24 pb-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8 pt-8">
          <div className="md:col-span-1">
            <img src={`${API}/resources/apig-logo-light.png?v=6`} alt="APIG Alliance" className="h-14 mb-4" />
            <p className="text-[#64748B] text-sm leading-relaxed mb-6">
              The Alliance for Predictive Intelligence & Growth.
            </p>
            <p className="text-[#D97706] text-sm font-medium">
              Validated intelligence.<br />High-stakes growth decisions.
            </p>
          </div>
          
          <div>
            <h4 className="text-xs font-medium uppercase tracking-wider text-[#D97706] mb-4">Navigate</h4>
            <ul className="space-y-3">
              <li><a href={anchor('#capabilities')} className="text-sm text-[#64748B] hover:text-white transition-colors">Capabilities</a></li>
              <li><a href={anchor('#challenges')} className="text-sm text-[#64748B] hover:text-white transition-colors">Challenges</a></li>
              <li><a href={anchor('#evidence')} className="text-sm text-[#64748B] hover:text-white transition-colors">Evidence</a></li>
              <li><a href={anchor('#leadership')} className="text-sm text-[#64748B] hover:text-white transition-colors">Leadership</a></li>
              <li><a href="/partners" className="text-sm text-[#64748B] hover:text-white transition-colors">Partner Firms</a></li>
              <li><a href="/newsletter" className="text-sm text-[#64748B] hover:text-white transition-colors">Newsletter</a></li>
              <li><a href="/media" className="text-sm text-[#64748B] hover:text-white transition-colors">Media</a></li>
              <li><a href={anchor('#contact')} className="text-sm text-[#64748B] hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-xs font-medium uppercase tracking-wider text-[#D97706] mb-4">Resources</h4>
            <ul className="space-y-3">
              <li><a href={`${API}/resources/apig-one-pager-new.pdf`} target="_blank" rel="noopener noreferrer" className="text-sm text-[#64748B] hover:text-white transition-colors">One-Pager Overview (PDF)</a></li>
              <li><a href={`${API}/resources/apig-firm-overview.pdf`} target="_blank" rel="noopener noreferrer" className="text-sm text-[#64748B] hover:text-white transition-colors">APIG Firm Overview (PDF)</a></li>
              <li><a href={`${API}/resources/asemap-advantage.pdf`} target="_blank" rel="noopener noreferrer" className="text-sm text-[#64748B] hover:text-white transition-colors">ASEMAP Advantage Explained (PDF)</a></li>
              <li><a href={`${API}/resources/apig-full-capabilities.pdf`} target="_blank" rel="noopener noreferrer" className="text-sm text-[#64748B] hover:text-white transition-colors">Full Capabilities Deck (PDF)</a></li>
              <li><a href="/evidence" className="text-sm text-[#64748B] hover:text-white transition-colors">Case Evidence Library</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-xs font-medium uppercase tracking-wider text-[#D97706] mb-4">Connect</h4>
            <div className="space-y-4">
              <div>
                <p className="text-sm text-white mb-1">Ready to discuss your challenge?</p>
                <button onClick={handleCtaClick} className="text-[#D97706] text-sm font-medium hover:text-white transition-colors">
                  Submit Your Challenge →
                </button>
              </div>
              <div className="pt-4 border-t border-[#0F2236]">
                <p className="text-xs text-[#64748B]">
                  Healthcare, MedTech, Pharma, Retail, Consumer, Financial Services, Hospitality, Energy, Entertainment.
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="pt-8 border-t border-[#0F2236] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#64748B]">
            &copy; {currentYear} The Alliance for Predictive Intelligence & Growth. All rights reserved.
          </p>
          <p className="text-xs text-[#64748B]">Confidential</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
